import { format } from "date-fns";

export const getScores = (reviews) => {
  if (reviews.length > 0) {
    return reviews.map((review, index) => {
      return review.score;
    });
  } else {
    return 0;
  }
};

export const scoreLength = (scores, grade) => {
  const score = scores.filter((e) => {
    return e === grade;
  });
  return score.length;
};

export const getReviewsWithTextLength = (reviews) => {
  const texts = reviews.filter((review) => review.text !== null);
  return texts.length;
};

export const formatDate = (dateString, language = "EN") => {
  const languageToLocale = {
    SL: "sl-SI", // Slovenian (Slovenia)
    HR: "hr-HR", // Croatian (Croatia)
   // SR: "sr-RS", // Serbian (Serbia) in Cyrlic
   SR: "sr-Latn-RS", // In latin
    EN: "en-US", // English (United States)
    IT: "it-IT", // Italian (Italy)
    DE: "de-DE", // German (Germany)
  };

  // Retrieve the locale from the map using the language, default to English (United States) if not found
  const locale = languageToLocale[language] || "en-US";

  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
  };

  return new Date(dateString).toLocaleDateString(locale, options);
};

export const getDate = (dateString, f) => {
  return format(new Date(dateString), f);
};
